import API from "../../../app/api";
export const getBestseller = async () => {
  try {
    const res = await API.get("/banners/best-seller-items");
    if (!res.data?.success) {
      throw new Error(res.data?.message || "Failed to fetch Bestseller");
    }
    return res.data?.data?.products || [];
  } catch (error) {
    console.error("getBestseller error:", error);
    return [];
  }
};